import type { KeyFigure } from "@/mocks/articles";

interface ArticleFiguresProps {
  items: KeyFigure[];
}

export default function ArticleFigures({ items }: ArticleFiguresProps) {
  return (
    <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((figure, index) => (
        <div
          key={figure.name}
          className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-5"
        >
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 font-heading text-sm font-black text-accent-800">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="min-w-0">
              <h4 className="truncate font-heading text-sm font-bold text-foreground-950">
                {figure.name}
              </h4>
              <p className="mt-0.5 truncate text-xs text-secondary-600">{figure.role}</p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">{figure.note}</p>
        </div>
      ))}
    </div>
  );
}